import { Button } from 'antd';
import ORGANIZATION from '../img/pages/invite/organization.svg';
import styles from './JoinOrganization.module.scss';

interface IJoinOrganizationProps {
  name: string;
  members: number;
  expires: number;
}

const JoinOrganization = ({ name, members, expires }: IJoinOrganizationProps) => {
  return (
    <div className={styles.organization}>
      <div className={styles.organization__main}>
        <img src={ORGANIZATION} alt="organization" className={styles.organization__main__image} />
        <div>
          <div className={styles.organization__main__name}>{name}</div>
          <div className={styles.organization__main__members}>{members} members</div>
        </div>
      </div>
      <div className={styles.organization__spacer}></div>
      <div className={styles.organization__action}>
        <div className={styles.organization__action__status}>expires in {expires} days</div>
        <div>
          <Button type="text" className={styles.organization__action__reject}>
            Reject
          </Button>
          <Button type="text" className={styles.organization__action__join}>
            Join
          </Button>
        </div>
      </div>
    </div>
  );
};

export default JoinOrganization;
